<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <a-table :dataSource="item.details" :columns="columns"  :pagination="false" class="tbl-receivable flex flex-col gap-y-8">
              <span slot="description" slot-scope="text,record">
<!--                v-if="record.expense !== undefined"-->
                <span class="flex gap-1">
                  <div>{{ record.expense ? 'Expense' : 'Service' }}: {{ limitTextTask(record.description) || '-' }}</div>
                  <small v-if="record.full_name !==undefined" class="self-end">{{ `(${record.full_name})` }}</small>
                </span>
              </span>
              <span slot="credit" slot-scope="text,record">
                <template v-if="record.credit">{{ record.amount }}</template>
              </span>
              <span slot="debit" slot-scope="text,record">
                <template v-if="!record.credit">{{ Math.abs(record.amount) }}</template>
              </span>
              <span slot="date" slot-scope="text,record">
                {{ setDateFormat(item.created_at) }}
              </span>
              <span slot="bill_id" slot-scope="text,record">
                <a v-if="item.bill !== undefined" href="#" @click="$router.push(`/billing/dashboard/${item.bill}`)">{{ item.bill_no }}</a>
              </span>
              <span slot="amount" slot-scope="text,record">
                 {{ Math.abs(record.amount) }}
              </span>
              <span v-if="item.client" slot="client" slot-scope="text,record">
                {{ item.client.name }}
              </span>
              <span v-if="item.matter" slot="matter" slot-scope="text,record">
                {{ item.matter.name }}
              </span>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_user',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeUser">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="user_value === 2"
              url="/account/list/"
              label="User"
              field="user"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="self-end w-full md:w-1/2"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Specific Matter
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 3"
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-0 w-full md:w-1/2"
              :is_include_matter="true"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Matter"
            />
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-center mt-0 w-full md:w-1/2"
              :is_include_matter="false"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Client"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent class="mt-4" :dateForm="form" />
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','BillingReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @hasDownloaded="hasDownloaded"
      @onProgress="onProgress"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from '@/components/pdf/ExportPdf'
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Inv No',
    dataIndex: 'invoice',
    key: '0',
    scopedSlots: { customRender: 'bill_id' },
  },
  {
    title: 'Date',
    dataIndex: 'created_at',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: '2',
    scopedSlots: { customRender: 'client' },
  },
  {
    title: 'Matter',
    dataIndex: 'matter',
    key: '3',
    scopedSlots: { customRender: 'matter' },
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: '4',
    scopedSlots: { customRender: 'amount' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '5',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: '6',
    scopedSlots: { customRender: 'credit' },
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: '7',
    scopedSlots: { customRender: 'debit' },
  },
];

export default {
  name: "ComponentInvoicePayment",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      user_value: null,
      title:'Invoice Payments',
      checked_matter_client: null,
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },

  methods:{
    handleChangeUser({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ user: [] })
      this.user_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.matter)  query.push({ field:'matters', condition: '=', value: values.matter })
            if (values.contact) query.push({ field:'to_contact', condition: '=', value: values.contact })
            if (values.practice_area) query.push({ field:'matters__practice_area', condition: '=', value: values.practice_area })
            if (values.user && values.user.length) query.push({ field:'matters__responsible', condition: 'in', value: values.user })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('billing/report/invoice/',{ query: query.length ? query : undefined })
            // from: values.from_date, to: values.to_date
            this.form.resetFields(['to_date','from_date'])
            this.visibleRes = true
            this.result     = Object.values(data)
            //this.checked_matter_client = 1
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>

